import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { getAccountingBasisLabel } from "@common/helpers/accountingBasis";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { ApplyCoaTemplateEntitySelectionRow } from "../applyCoaTemplateEntitySelection.types";

export const ApplyCoaEntityBasisCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCoaTemplateEntitySelectionRow,
        unknown
    >) => {
        if (row.original.isClientRow) {
            return <ViewTableCell />;
        }

        const { bases } = row.original;
        const label =
            bases.length === 0
                ? "-"
                : bases
                      .map((basis) => getAccountingBasisLabel(basis))
                      .join(", ");

        return (
            <ViewTableCell>
                <span className="text-secondary">{label}</span>
            </ViewTableCell>
        );
    },
);
